module.exports = __webpack_public_path__ + "img/jht-icon-14-act.fb768392.png";